import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import Home from './Components/Home';
import Mywork from './Components/Mywork';
import Resources from './Components/Resources';
import Contacts from './Components/Contacts';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
        <Home/>
        <Mywork/>
        <Resources/>
        <Contacts/>
        <Footer/>
    </div>
  );
}

export default App;
